:host {
    display: block;
}

.base-modal-body {
    width: 100%;
    max-width: 648px;
    min-width: 300px;
    min-height: 118px;
}

.modal-backdrop {
    align-items: center;
    text-align: center;
}

.modal-z-index {
   z-index: 10110;
}
